import { AddTicker } from './AddTicker';
import { DeleteTicker } from './DeleteTicker';
import { CreateWatchlist } from './CreateWatchlist';
import { DeleteWatchlist } from './DeleteWatchlist';
import { EditWatchlist } from './EditWatchlist';
import { Notifications } from './Notifications';

export const WatchlistModals = () => {
  return (
    <>
      <AddTicker />
      <DeleteTicker />
      <CreateWatchlist />
      <EditWatchlist />
      <DeleteWatchlist />
      <Notifications />
    </>
  );
};
